export default __webpack_public_path__ + "images/QR.f5e9ef0.png";